import { gql } from 'graphql-tag';

export default gql`
    query homepage($articleLimit: Int, $preview: Boolean) {
        homepage(preview: $preview) {
            ... on Homepage {
                h1TitleTag
                brandHeadline
                heroImage {
                    altText
                    url
                    focalPoint
                    height
                }
                contentBlock {
                    ... on ArticleCollection {
                        title
                        description
                        contentType
                        seeMoreLink {
                            buttonLabel
                            buttonUrl
                            category
                        }
                        articles(limit: $articleLimit) {
                            items {
                                heroImage {
                                    altText
                                    focalPoint
                                    url
                                }
                                id
                                slug
                                snippet
                                title
                                publicationDateAndTime
                                category {
                                    slug
                                }
                            }
                        }
                    }
                    ... on CampaignCta {
                        contentType
                        ccTitle: title
                        ccDescription: description
                        image {
                            url
                            altText
                            focalPoint
                        }
                    }
                    ... on Banner {
                        title
                        bannerDescription: description {
                            content
                            data
                            nodeType
                        }
                        buttons {
                            buttonLabel
                            buttonUrl
                            category
                            eventTracking {
                                eventAction
                                eventLabel
                                eventCategory
                                segmentEventName
                            }
                        }
                        backgroundColour
                        imagePosition
                        imageSrc
                        contentType
                    }
                    ... on TwoColumnSplit {
                        leftColumn {
                            ... on ContentfulImage {
                                url
                                altText
                            }
                            ... on ComponentRichText {
                                content {
                                    content
                                    data
                                    nodeType
                                }
                            }
                        }
                        rightColumn {
                            ... on ContentfulImage {
                                url
                            }
                            ... on ComponentRichText {
                                content {
                                    content
                                    data
                                    nodeType
                                }
                            }
                        }
                    }
                    ... on ReactComponent {
                        title
                        contentType
                        componentName
                        body
                        __typename
                    }
                }
            }
            ... on CMSError {
                errorCode
            }
        }
    }
`;
